export default "__VITE_ASSET__CLyX0nwi__"